'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;

    this.page = 1;
    this.params = {
      offset: this.page - 1,
      limit: 20,
      sortBy: 'createdAt',
      order: -1
    };
  }

  $onInit() {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page;
    }
    this.getApps();
  }

  getApps() {
    this.params.offset = (this.page - 1) * this.params.limit;
    this.$http.get('/api/apps', {params: this.params}).then(response => {
      this.apps = response.data;
    });
  }

  deleteApp(id) {
    if (confirm("确定？")) {
      this.$http.delete('api/apps/' + id).then(response => {
        this.getApps();
      });
    }
  }

  pageChanged() {
    this.$state.go('apps.list', {page: this.page});
  }

}



// WEBPACK FOOTER //
// ./client/app/apps/list/list.controller.js